import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import Alert from 'react-s-alert';


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '700px'
	
  }
};


const database=firebase.database();


class ModalCalificaciones extends Component{
	
	constructor(props)
	{
		
		super(props)
		this.state={
			isActive:false,
			preguntas:[]
			
		}
		
		this.calificacionesRef=database.ref().child('Calificaciones');
		this.toggleModal=this.toggleModal.bind(this);
		this.renderTable=this.renderTable.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.ingresarPregunta=this.ingresarPregunta.bind(this);

	}


	componentWillMount(){

			Modal.setAppElement('body');

	}
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
	}

	

	handleSubmit(event){
	
		let tipo=this.tipo.value;
		

		if(this.state.preguntas.length===0){

				Alert.warning('Debes ingresar al menos una pregunta', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
		
		}
		else{

				let pushKey=this.calificacionesRef.push({
					tipo:tipo,
					estado:'Activo'
				})
			

				for(let i=0;i<this.state.preguntas.length;i++){

					this.calificacionesRef.child(pushKey.getKey()).child('preguntas').push({
						
						item:this.state.preguntas[i].pregunta
					});
				}

				
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});


		}


		event.preventDefault();
	}

	

	

	ingresarPregunta(){

		let pregunta=this.pregunta.value;


		let busqueda=this.state.preguntas.find(preguntas=>preguntas.pregunta===pregunta);

		if(busqueda===undefined){

			if(pregunta!==""){

				
				
				this.state.preguntas.push({
					key:(this.state.preguntas.length+1),
					pregunta:pregunta
				})
				
				this.setState({

				preguntas:this.state.preguntas
				})
					
			}
		}
		
		this.pregunta.value="";
	}

	handleClickEliminarPagina(row){
	
		
	
		let newArray=this.state.preguntas.filter(preguntas=>preguntas.pregunta!==row.pregunta);

		this.setState({
			preguntas:newArray
		})

	}
	



	btnEliminarFormatter(cell,row){
		
		
		return <p className="glyphicon glyphicon-remove btn-eliminar" onClick={() => {this.handleClickEliminarPagina(row)}} ></p>
	}



	renderTable(){
	
		if(this.state.preguntas.length===0){
			
			return <center><p><b>Ingresa una pregunta</b></p></center>;
				
		}
		else{
			return(
			
				<BootstrapTable data={ this.state.preguntas}
					 ref='table'
					 pagination={ false }
					 search={ false }
					 hover
					 >
					<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					<TableHeaderColumn dataField='pregunta' dataSort={true}>Preguntas</TableHeaderColumn>
					<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEliminarFormatter.bind(this) }>Eliminar</TableHeaderColumn>					
				</BootstrapTable>		
					
			)
		}
		
		
	}


	
	render(){
		
		return(
		
			<div className="modal_calificaciones">
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				
				
				
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
				


			
					<form method="POST" action="" onSubmit={this.handleSubmit}>


					<h3>Agregar Calificación</h3>
					<hr/>
					<div className="form-group">
							<label htmlFor="">Tipo de Calificación</label>
							<input type="text" required autoComplete="off"
								placeholder="Tipo"  className="form-control"
								ref={input=>{this.tipo=input}}
					/>
					
	
						<h4>Ingresa una pregunta</h4>
						<hr/>
						
						<input type="text" name="pregunta" className="form-control" 
						 autoComplete="off" placeholder="Ingresa una pregunta" 
							ref={input=>{this.pregunta=input}}
						/>
						<br/>
						<button type="button" className="btn btn-success btn-sm" onClick={this.ingresarPregunta}>Agregar pregunta</button>
	
					
					<br/>
							
					{this.renderTable()}
					
					
					</div>
					
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
				
				</Modal>
				
				
			</div>
		
		);		
	}
	
}

export default ModalCalificaciones;


// WEBPACK FOOTER //
// ./src/Components/Calificaciones/ModalCalificaciones.js